import { useDispatch, useSelector } from 'react-redux'
import CardGrey from '../../../common/CardGrey'
import CheckboxCell from '../../../common/interactive/CheckboxCell'
import classes from '../Shared/Item.module.css'
import { caseActions } from '../../../../store/case'
import { caseQuickUpdate } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import InputBox from '../../../common/interactive/InputBox'

const CaseSummarySidebar = ({itemData, apiCase, permissionType}) => {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const updateHandler = async (data) => {
       
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        let dispatchObj = {
            folder: data.identifier.folder,
            item: {
                fields: [
                    {
                        field: data.identifier.field,
                        value: data.data.value
                    },
                ]            
            }
        }
        setTimeout(() => {
            dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
        }, 0)

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }
    }

    return <CardGrey minHeight={'100%'}>
        <div className={classes.container}>
            <div className={classes.sidebar_row_block}>
                <InputBox currentValue={activeCase.patient?.driver_license} label={"Driver’s License"} type={'text'} name={'driver_license'} action={updateHandler} identifier={{folder: 'patient',type: 'case_patient', field: 'driver_license', type_id: null, permissionType: permissionType}} />
            </div>
            {itemData?.additional && <>
                <div className={`${classes.sidebar_row} ${classes.sidebar_row_separator}`}></div>

                <div className={classes.sidebar_row_block}>
                    <InputBox currentValue={itemData.additional.property_damage} label={'Property Damage'} type={'text'} name={'property_damage'} action={updateHandler} identifier={{folder: 'additional',type: apiCase, field: 'property_damage', type_id: null, permissionType: permissionType}} />
                </div>

                <div className={classes.sidebar_row_block}>
                    <InputBox currentValue={itemData.additional.people_involved} label={'People involved in the accident'} type={'text'} name={'people_involved'} action={updateHandler} identifier={{folder: 'additional',type: apiCase, field: 'people_involved', type_id: null, permissionType: permissionType}} />
                </div>

                <div className={classes.sidebar_row_block}>
                    <InputBox currentValue={itemData.case_police_report.number_of_vehicles} label={'Number of Vehicles'} type={'text'} name={'number_of_vehicles'} action={updateHandler} identifier={{folder: 'case_police_report',type: apiCase, field: 'number_of_vehicles', type_id: null, permissionType: permissionType}} />
                </div>    

                <div className={`${classes.sidebar_row} ${classes.sidebar_row_separator}`}></div>

                <div className={classes.sidebar_row}>
                    <CheckboxCell checked={itemData.additional.outside_lien_check} direction={'reverse'} label={'Outside Liens Check'} name={'outside_lien_check'}  action={updateHandler} identifier={{folder: 'additional',type: apiCase, field: 'outside_lien_check', type_id: null, permissionType: permissionType}}/>
                </div>

                <div className={classes.sidebar_row_block}>
                    <InputBox currentValue={itemData.additional.outside_lien_type} label={'Lien Type'} type={'text'} name={'outside_lien_type'} action={updateHandler} identifier={{folder: 'additional',type: apiCase, field: 'outside_lien_type', type_id: null, permissionType: permissionType}} />
                </div>

                <div className={classes.sidebar_row_block}>
                    <InputBox currentValue={itemData.additional.outside_lien_amount} label={'Lien Amount'} type={'text'} name={'outside_lien_amount'} action={updateHandler} identifier={{folder: 'additional',type: apiCase, field: 'outside_lien_amount', type_id: null, permissionType: permissionType}} />
                </div>
            </>}
        </div>
    </CardGrey>
}

export default CaseSummarySidebar